module.exports = __webpack_public_path__ + "img/go_point.847011c4.png";